/* eslint-disable */
import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { ixApi } from "./api";
import { toast } from "@shared/hooks/use-toast";
import { queryClient } from "@shared/api/queries/queryClient";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";

export const useGetChoices = (choiceType: string) => {
  const remoteUtilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ix.choices(choiceType, remoteUtilityId),
    () => ixApi.getChoices(remoteUtilityId, choiceType),
    {
      enabled: !!remoteUtilityId,
    },
  );
};

export const useSetupConnection = () => {
  return useSmartMutation((payload: any) => ixApi.setupConnection(payload), {
    onSuccess: () => {
      toast({
        title: "Success",
        description: "Connection setup successfully.",
        variant: "default",
      });
      queryClient.refetchQueries({
        queryKey: ["ix", "erp-integration"],
      });
    },
    onError: (err: Error) => {
      toast({
        title: "Error",
        description: err.message,
        variant: "destructive",
      });
    },
  });
};

export const useUpdateConnectionSetup = (connectionId: string) => {
  return useSmartMutation(
    (payload: any) => ixApi.updateConnectionSetup(connectionId, payload),
    {
      onSuccess: () => {
        toast({
          title: "Success",
          description: "Connection setup updated successfully.",
          variant: "default",
        });
        queryClient.refetchQueries({
          queryKey: ["ix", "erp-integration"],
        });
        queryClient.refetchQueries({
          queryKey: ["ix", "editconnectionDetails", connectionId],
        });
        queryClient.refetchQueries({
          queryKey: ["ix", "connectionDetails", connectionId],
        });
      },
      onError: (err: Error) => {
        toast({
          title: "Error",
          description: err.message,
          variant: "destructive",
        });
      },
    },
  );
};

export const useGetConnectionDetails = (
  connectionId: string,
  url?: boolean,
) => {
  const remoteUtilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ix.editconnectionDetails(connectionId, url),
    () => ixApi.editGetConnectionDetails(connectionId, remoteUtilityId),
    {
      enabled: !!connectionId && !!url,
    },
  );
};

export const useGetConnectorsCatalog = (family: string) => {
  const remoteUtilityId = useRemoteUtilityId();
  return useSmartQuery(
    QueryKeyFactory.module.ix.connectorsCatalog(family),
    () => ixApi.getConnectorsCatalog(remoteUtilityId, family),
    {
      enabled: !!remoteUtilityId && !!family,
    },
  );
};
